import { SxProps, Theme } from '@mui/system';

const styles = {
  container: {
    display: 'flex',
    flex: 1,
    flexDirection: { xs: 'column', md: 'row' },
  },
  stat: {
    backgroundColor: 'common.lightBackgroundColor',
    padding: '8px 16px',
    marginRight: '4px',
    borderRadius: 1,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'baseline',
    gap: '6px',
    whiteSpace: 'nowrap',
  },
  label: {
    fontSize: 12,
    color: 'common.gray',
  },
  value: {
    fontSize: 14,
    fontWeight: '600',
    color: 'grey.800',
  },
} satisfies Record<string, SxProps<Theme>>;

export default styles;
